export default __webpack_public_path__ + "static/media/detail_mobile_14_7.e8646749.jpg";